import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropTypes from 'prop-types';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';

//icons
import NotificationsIcon from '@material-ui/icons/Notifications';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ChatIcon from '@material-ui/icons/Chat';

//redux
import { connect } from 'react-redux';
import { markNotificationsRead } from '../../redux/actions/userActions';

const Link = require('react-router-dom').Link;

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null
        }
    }

    handleOpen = (event) => {
        let target = event.target;
        this.setState(() => {
            return {
                anchorEl: target
            }
        })
    }

    handleClose = () => {
        this.setState(() => {
            return {
                anchorEl: null
            }
        })
    }

    onMenuOpened = () => {
        let unreadNotificationsIds = this.props.notifications.filter((notification) => !notification.read).map((notification) => notification.notificationId);
        this.props.markNotificationsRead(unreadNotificationsIds);
    }

    render() {
        const notifications = this.props.notifications;
        const anchorEl = this.state.anchorEl;
        dayjs.extend(relativeTime);
        let notificationIcon;
        if (notifications && notifications.length > 0) {
            notifications.filter((notification) => notification.read === false).length > 0 ? notificationIcon = (
                <Badge badgeContent={notifications.filter(notification => notification.read === false).length} color='primary'>
                    <NotificationsIcon />
                </Badge>
            ) : notificationIcon = (<NotificationsIcon />)
        } else {
            notificationIcon = <NotificationsIcon />
        }
        let notificationsMarkup = notifications && notifications.length > 0 ? (
            notifications.map((notification) => {
                const verb = notification.type === 'like' ? 'liked' : 'commented on';
                const time = dayjs(notification.createdAt).fromNow();
                const iconColor = notification.read ? 'primary' : 'secondary';
                const icon = notification.type === 'like' ? (
                    <FavoriteIcon color={iconColor} style={{ marginRight: 10 }} />
                ) : (
                        <ChatIcon color={iconColor} style={{ marginRight: 10 }} />
                    );
                return (
                    <MenuItem key={notification.createdAt} onClick={this.handleClose}>
                        {icon}
                        <Typography component={Link} color='primary' variant='body1' to={`/users/${notification.recipient}/soundoff/${notification.soundOffId}`} >
                            {notification.sender} {verb} your sound off! {time}
                        </Typography>

                    </MenuItem>
                )
            })
        ) : (
                <MenuItem onClick={this.handleClose}>
                    No notificaitons!
                </MenuItem>
            )

        return (
            <React.Fragment>
                <Tooltip placement='top' title='Notifications' >
                    <IconButton aria-owns={anchorEl ? 'simple-menu' : undefined} aria-haspopup='true' onClick={this.handleOpen}>
                        {notificationIcon}
                    </IconButton>
                </Tooltip>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose} onEntered={this.onMenuOpened}>
                    {notificationsMarkup}
                </Menu>
            </React.Fragment>
        )
    }
}

Notifications.propTypes = {
    markNotificationsRead: PropTypes.func.isRequired,
    Notifications: PropTypes.array.isRequired
}



const mapStateToProps = (state) => ({
    notifications: state.user.notifications
})

export default connect(mapStateToProps, { markNotificationsRead })(Notifications);
